import { z } from "zod";
/** The records a module's answers can be about. */
export const InstanceKindSchema = z.enum(["session"]);
/** Which of those records a module is answered for. */
export const SelectionSchema = z.enum(["one"]);
/** What a module's answers are about, from its entity link. */
export const InstancesSchema = z.union([
    z.object({ of: InstanceKindSchema, which: SelectionSchema }),
    z.literal("notSupported"),
]);
/**
 * What each entity link means for a module's answers. Every seeded link is listed,
 * so supporting one replaces its `"notSupported"` rather than adding a case
 * somewhere else.
 */
export const ENTITY_LINKS = {
    case: "notSupported",
    case_participants_any: "notSupported",
    case_participants_all: "notSupported",
    session: { of: "session", which: "one" },
    session_participants_any: "notSupported",
    session_participants_all: "notSupported",
};
const isEntityLinkKey = (key) => Object.hasOwn(ENTITY_LINKS, key);
/**
 * What a module's answers are about. Every stored entity link is a seeded
 * one, so a link the registry doesn't know is a missing entry, and throws.
 */
export function instancesOf(entityLink) {
    if (!isEntityLinkKey(entityLink)) {
        throw new Error(`Entity link "${entityLink}" has no meaning for a module's answers`);
    }
    return ENTITY_LINKS[entityLink];
}
